import { useTranslation } from 'react-i18next';
import { useSubformStyles } from './useSubformStyles';
import { Label, Textarea } from '@fluentui/react-components';
import { useCallback, useId } from 'react';
import { customerUpdatesDataConstraints } from '../../../../../store/features/customerUpdates/customerUpdates.thunks';

export interface FeedbackMessageSubformProps {
    value: string;
    onChange: (value: string) => void;
}

const FeedbackMessageSubform: React.FC<FeedbackMessageSubformProps> = ({
    value,
    onChange,
}) => {
    const { t } = useTranslation();
    const styles = useSubformStyles();

    const textareaId = useId();

    const onChangeCallback = useCallback(
        (value: string) => {
            onChange(
                value.slice(
                    0,
                    customerUpdatesDataConstraints.maxFeedbackMessageLength
                )
            );
        },
        [onChange]
    );

    return (
        <div className={styles.field}>
            <Label htmlFor={textareaId}>
                {t('CustomerDialog_ProvideFeedback')}
            </Label>
            <Textarea
                id={textareaId}
                value={value}
                onChange={(_, data) => onChangeCallback(data.value)}
            />
        </div>
    );
};

export default FeedbackMessageSubform;
